export default __webpack_public_path__ + "static/media/icon_professional_trajectory.fbd6c8a1.svg";